import { createSlice } from '@reduxjs/toolkit'
import { RunRecord } from '../../components/adminModule/safeTypes'

export interface Config {
    UnitReviewOptions?: unknown
    ServicePipelines?: unknown
    all: All
    users: Users
    'user-notifies': UserNotifies
    units: Units
    'unit-keys': UnitKeys
    viewings: Viewings
    offers: Offers
    properties: Properties
    landlords: Landlords
    tenants: Tenants
    documents: Documents
    tasks: Tasks
    orders: Orders
    'unit-advertises': UnitAdvertises
}

export interface All {
    Country: string[]
    Gender: string[]
    Currency: string[]
    Area: string[]
    Bank: string[]
}

export interface Users {
    Category: string[]
    Settings: Settings
}

export interface Settings {
    Emirate: string[]
    Memdership: string[]
    Type: string[]
}

export interface UserNotifies {
    Rule: string[]
    Type: string[]
}

export interface Units {
    Type: string[]
    Fit: string[]
    View: string[]
    Features: string[]
    Amenities: string[]
    Appliances: string[]
    Marketing: Marketing
    ManagedBy: string[]
    Statuses: string[]
    unitCategories:    {
    "Residential": string[],
    "Commercial": string[]
}
}


export interface Marketing {
    Status: string[]
    Use: string[]
}

export interface UnitKeys {
    Status: string[]
}

export interface Viewings {
    Notify: string[]
    Statuses: string[]
}

export interface Offers {
    Type: Type
    Notify: string[]
    Statuses: string[]
}

export interface Type {
    Residential: Residential
    Sale: Sale
}

export interface Residential {
    Occupants: string[]
    PetType: string[]
}

export interface Sale {
    Type: string[]
}

export interface Portfolios {
    Statuses: string[]
}

export interface Properties {
    Type: string[]
    Statuses: string[]
}

export interface Utilities2 {
    GasSupplierName: string[]
    CoolingProviderName: string[]
}

export interface Landlords {
    PowerOfAttorney: PowerOfAttorney
    Statuses: string[]
}

export interface PowerOfAttorney {
    Activity: string[]
    Status: string[]
    Roles: string[]
}

export interface Leases {
    Payments: Payments
    Statuses: string[]
}

export interface Payments {
    PaymentMethod: string[]
    BeneficiaryTitle: string[]
}

export interface Tenants {
    Statuses: string[]
}

export interface Documents {
    Type: Type2
    Statuses: string[]
}

export interface Type2 {
    PowerOfAttorney: PowerOfAttorney2
    TitleDeed: TitleDeed
}

export interface PowerOfAttorney2 {
    Activity: string[]
    Roles: string[]
}

export interface TitleDeed {
    Type: string[]
    Property: Property
}

export interface Property {
    Type: string[]
}

export interface Tasks {
    Type: string[]
    Checkpoints: Checkpoints
    Works: Works
    Statuses: string[]
}

export interface Checkpoints {
    Type: string[]
}

export interface Works {
    Status: string[]
}

export interface Orders {
    Statuses: string[]
    Service: Service
}

export interface Service {
    FindingBuyer: FindingBuyer
    FindingTenant: FindingTenant
    LegalNotice: LegalNotice
    Maintenance: Maintenance
    PowerOfAttorney: PowerOfAttorney3
    RentalDisputeCenter: RentalDisputeCenter
    BrokerSubscription: BrokerSubscription
}

export interface FindingBuyer {
    Package: string[]
    AdditionalServices: string[]
}

export interface FindingTenant {
    Package: string[]
    AdditionalServices: string[]
}

export interface LegalNotice {
    Type: string[]
}

export interface Maintenance {
    Type: string[]
}

export interface PowerOfAttorney3 {
    Roles: string[]
}

export interface RentalDisputeCenter {
    Against: string[]
}

export interface BrokerSubscription {
    Package: string[]
}

export interface Comments {
    Statuses: string[]
}

export interface UnitAdvertises {
    Status: string[]
}

export interface AreaGroup {
    id: number;
    name: string;
    areas: string[];
    multiplier: number;
    vipStatus?: boolean;
    unitsCount?: number;
}
   
interface AppState {
    fullscreenVideo: boolean
    config?: Config
    configId: number | null
    eventsRunsHistory: RunRecord[]
     allAreas:AreaGroup[]
    microphoneAccessProvided: boolean
    userDevice: 'IPhone' | 'Android' | ''
    dataLoaded: boolean
    configDBState: null
    socketTimeout : number
}

const initialState: AppState = {
    fullscreenVideo: false,
    config: undefined,
    configId: null,
    eventsRunsHistory:[],
    allAreas:[], 
    microphoneAccessProvided: false,
    userDevice: '',
    dataLoaded: false,
    configDBState: null,
    socketTimeout: new Date().getTime()
}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setFullscreenVideo (state, action) {
            state.fullscreenVideo = action.payload
        },
        setConfig (state, action) {
            state.config = action.payload
        },
        setEventsRunsHistory (state, action) {
            state.eventsRunsHistory = action.payload
        },
        setConfigId(state, action) {
  state.configId = action.payload
},
        setAreas(state, action) {
            state.allAreas = action.payload
        },
        setMicrophoneAccessProvided (state, action) {
            state.microphoneAccessProvided = action.payload
        },
        setUserDevice (state, action) {
            state.userDevice = action.payload
        },
        setDataLoaded (state, action) {
            state.dataLoaded = action.payload
        },
        setConfigDBState (state, action) {
            state.configDBState = action.payload
        },  
        setSocketTimeout (state, action) {
            state.socketTimeout = action.payload
        }

    }
})

export const {
    setFullscreenVideo,
    setConfig,
    setConfigId,
    setEventsRunsHistory,
    setMicrophoneAccessProvided,
    setUserDevice,
    setDataLoaded,
    setConfigDBState,
    setSocketTimeout , setAreas
} = appSlice.actions
export default appSlice.reducer
